import { HttpClient } from '@angular/common/http';
import {
  TRANSLOCO_LOADER,
  Translation,
  TranslocoLoader,
  TRANSLOCO_CONFIG,
  translocoConfig,
  TranslocoModule,
} from '@ngneat/transloco';
import { Injectable, NgModule } from '@angular/core';
import { environment } from '../environments/environment';

const SUPPORTED_LANGS = ['en', 'ar', 'ru'] as const;

function normalizeLanguage(rawLang: string | null): string | null {
  if (!rawLang) {
    return null;
  }

  const normalizedLang = rawLang.toLowerCase().replace('_', '-').split('-')[0];
  return SUPPORTED_LANGS.includes(normalizedLang as (typeof SUPPORTED_LANGS)[number])
    ? normalizedLang
    : null;
}

function getInitialLanguage(): string {
  if (typeof window === 'undefined') {
    return 'en';
  }

  const queryLanguage = normalizeLanguage(
    new URLSearchParams(window.location.search).get('kc_locale'),
  );
  if (queryLanguage) {
    window.localStorage.setItem('lang', queryLanguage);
    return queryLanguage;
  }

  return normalizeLanguage(window.localStorage.getItem('lang')) || 'en';
}

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(`assets/i18n/${lang}.json`);
  }
}

@NgModule({
  imports: [TranslocoModule],
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: ['en', 'ar', 'ru'],
        defaultLang: getInitialLanguage(),
        fallbackLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: environment.production,
      }),
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
  ],
})
export class TranslocoRootModule {}
